import { hashHistory } from 'react-router';

// Get 'app' path
import { path as APP_PATH } from '../..';

// All paths
const PATHS = {
  PRODUCTION: 'production',
  DEVICE_BATCHES_PATHS: {
    DEVICE_BATCHES: 'device_batches',
  },
};

// Exported paths
export const MAIN_PATH = PATHS.PRODUCTION;
export const DEVICE_BATCHES_PATH = PATHS.DEVICE_BATCHES_PATHS.DEVICE_BATCHES;

// Root
const APP_PRODUCTION_PATH = `${APP_PATH}/${MAIN_PATH}`;
const APP_DEVICE_BATCHES_PATH = `${APP_PRODUCTION_PATH}/${DEVICE_BATCHES_PATH}`;

// --- Device batches --- //
export const listDeviceBatchesPath = () => APP_DEVICE_BATCHES_PATH;
export const navigateToDeviceBatchesList = () => {
  hashHistory.push(listDeviceBatchesPath());
};

export const addDeviceBatchesPath = () => `${APP_DEVICE_BATCHES_PATH}/add`;
export const navigateToDeviceBatchesAdd = () => {
  hashHistory.push(addDeviceBatchesPath());
};

export const showDeviceBatchesPath = (id) => `${APP_DEVICE_BATCHES_PATH}/${id}`;
export const navigateToDeviceBatchesShow = (id) => {
  hashHistory.push(showDeviceBatchesPath(id));
};



// WEBPACK FOOTER //
// ./routes/app/routes/production/navigation.js